import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { VideoClipsCanvas } from '@/features/app-shell/canvases/video-clips-canvas'

export const Route = createFileRoute('/app/projects_/$projectId')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppProjectDetailPage,
})

function AppProjectDetailPage() {
  const { projectId } = Route.useParams()

  return (
    <AppShell activePath="/app/projects">
      <VideoClipsCanvas projectId={projectId} />
    </AppShell>
  )
}
